import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { setDescriptionSearchText, setIsDescriptionSearchOpen } from '@store/supplier/action';

import ModalContainer from '@/components/modals/ModalContainer';
import { getFabricByDescription } from '@/services/materialService';

const DescriptionSearch = ({ setMaterialsDataList, selectedBalance, selectedCountry, onCloseModal }) => {
	const [searchedText, setSearchedText] = useState('');
	const dispatch = useDispatch();
	const searchInputRef = useRef();

	useEffect(() => {
		if (searchInputRef.current) {
			searchInputRef.current.focus();
		}
	}, []);

	const getSearchReasult = async () => {
		dispatch(openLoader());
		const response = await getFabricByDescription(
			encodeURIComponent(searchedText),
			selectedBalance?.id,
			selectedCountry?.id
		);
		setMaterialsDataList(response);
		window.scroll(0, 0);
		dispatch(closeLoader());
	};

	const handleSearch = (e) => {
		const currentText = e.target.value;

		if (e.key === 'Enter') {
			getSearchReasult();
			dispatch(setDescriptionSearchText(currentText));
			dispatch(setIsDescriptionSearchOpen(false));
		}
	};

	return (
		<ModalContainer className="description-search-modal" onCloseModal={onCloseModal}>
			<div className="common-popup description-search-modal">
				<div className="common-popup-body">
					<div className="form-group mb-0">
						<textarea
							placeholder="Enter description"
							onKeyDown={(e) => handleSearch(e)}
							onChange={(e) => setSearchedText(e.target.value)}
							name="descriptionSearch"
							ref={searchInputRef}
						/>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default DescriptionSearch;
